import clsx from 'clsx';
import React from 'react';
import { Button } from 'semantic-ui-react';
import { ButtonProps } from '../../interfaces/ButtonProps';
import './POSButton.less';

export interface Props
  extends Omit<ButtonProps, 'size' | 'color' | 'circular' | 'primary'> {
  className?: string;
}

export const POSButton = (props: Props) => (
  <Button
    type={props.type ?? 'button'}
    icon={props.icon}
    labelPosition={
      props.icon && !props.labelPosition ? 'left' : props.labelPosition
    }
    inverted={props.inverted}
    floated={props.floated}
    secondary
    circular
    size={props.secondary ? 'small' : 'medium'}
    className={clsx('p-os-button', props.className, {
      'secondary-padding': props.secondary,
    })}
    disabled={props.disabled}
    onClick={props.onClick}
  >
    {props.children}
  </Button>
);
